/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/date/FormatDate.ts
 * @create:      2025-06-27 21:52:05.543
 * @modify:      2025-07-11 21:19:12.904
 * @version:     6.0.0
 * @times:       11
 * @lines:       55
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { DateTime } from "../class/DateTime";
import { DateTimeFormat } from "../enum/DateTimeFormat";

/**
 * Formats a given Date object into a string based on the specified format and optional timezone offset.
 *
 * @param date - The Date object to format.
 * @param format - Optional. The format to use for the output string. Can be a `DateTimeFormat` or a string.
 * @param timezoneOffset - Optional. The timezone offset (in minutes) to apply when formatting the date.
 *                         If not provided, the date is formatted in the local timezone.
 * @returns The formatted date string.
 * 
 * @since 1.0.5
 * @version 2021-08-06
 */
export function FormatDate(date: Date, format?: DateTimeFormat | string, timezoneOffset?: number): string {
    if (timezoneOffset === undefined) {
        return DateTime.From(date).ToLocalString(format);
    }

    return DateTime.From(date).ToString(format, timezoneOffset);
}
